<template>
  <el-row style="height: 480px;width: 100%;margin-top: 80px;">
    <el-row style="width: 100%;height: 100px;">
      <el-row class="solution-logo" />
    </el-row>
    <el-row style="width: 100%;height: 300px;margin-top: 80px;">
      <el-col style="width: 24%;height: 100%;margin-left: 14%;">
        <el-row @click.native="changeRoute('/solution', '411')" class="school-pic" />
        <el-row class="solution-icon">
          <el-col style="width: 43%;text-align: right;height: 60px;line-height: 60px;margin-right: 2%;">
            <i class="yk-icon-school-ext" style="font-size: 24px;" />
          </el-col>
          <el-col style="width: 55%;text-align: left;height: 60px;line-height: 60px;">绿 色 高 校</el-col>
        </el-row>
      </el-col>
      <el-col style="width: 24%;height: 100%;">
        <el-row @click.native="changeRoute('/solution', '412')" class="factory-pic"/>
        <el-row class="solution-icon">
          <el-col style="width: 44%;text-align: right;height: 60px;line-height: 60px;margin-right: 1%;">
            <i class="yk-icon-factory" style="font-size: 30px;" />
          </el-col>
          <el-col style="width: 55%;text-align: left;height: 60px;line-height: 60px;">绿 色 工 厂</el-col>
        </el-row>
      </el-col>
      <el-col style="width: 24%;height: 100%;">
        <el-row @click.native="changeRoute('/solution', '413')" class="witpark-pic" />
        <el-row class="solution-icon">
          <el-col style="width: 43%;text-align: right;height: 60px;line-height: 60px;margin-right: 2%;">
            <i class="yk-icon-witpark" style="font-size: 30px;" />
          </el-col>
          <el-col style="width: 55%;text-align: left;height: 60px;line-height: 60px;">智 慧 园 区</el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'Solutions',
  methods: {
    changeRoute(path, page) {
      this.$router.push({path: path, query: {page: page}})
    }
  }
}
</script>

<style scoped>
  .solution-logo {
    background: url("../../assets/solutions.png") no-repeat;
    width: 470px;
    margin-left: calc(50% - 235px);
    height: 100px;
    /*cursor: pointer;*/
  }
  .factory-pic {
    background: url("../../assets/factory.png") no-repeat;
    margin-left: calc(50% - 150px);
    width: 300px;
    height: 180px;
    cursor: pointer;
  }
  .school-pic {
    background: url("../../assets/school.png") no-repeat;
    margin-left: calc(50% - 150px);
    width: 300px;
    height: 180px;
    cursor: pointer;
  }
  .witpark-pic {
    background: url("../../assets/witpark.png") no-repeat;
    margin-left: calc(50% - 150px);
    width: 300px;
    height: 180px;
    cursor: pointer;
  }
  .solution-icon {
    font-size: 20px;
    font-weight: bold;
    color: #00bf86;
    height: 60px;
    line-height: 60px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/Solutions.vue